<!--补充单据-->
<template>
  <div>
    <div style="display:flex;align-items: flex-end;">
      <upload-pic :pictureList="urlList" :isDisabled="true" :limit="3"></upload-pic>
      <el-button class="bill-btn" type="text" @click="billDialog.visible = true" v-if="userInfo.identity !==3">补传单据</el-button>
    </div>
    <!-- 补传单据 - 弹窗 -->
    <el-dialog
        title="补传单据"
        :visible.sync="billDialog.visible"
        width="30%">
        <upload-pic ref="upload" :fileIds="fileIds" :fileSize='3' :pictureList="urlList" :limit="3" :isDisabled="false" :delet="true"></upload-pic>
        <label class="upload-text">建议＜3M，最多3张</label>
        <span slot="footer" class="dialog-footer">
        <el-button @click="billDialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import assignmentManage from '@/store/assignmentManage/index'
import {UPDATETASKURLS} from '@/store/assignmentManage/types'
import UploadPic from './uploadImage'
import user from '@/store/user/index'
export default {
  props: ['taskEdit', 'saas'],
  components: {
    UploadPic
  },
  data () {
    return {
      // 补传单据
      billDialog: {
        visible: false
      },
      fileIds: []
    }
  },
  mounted () {

  },
  methods: {
    // 保存补传单据
    submit () {
      let urlList = this.$refs.upload.fileList.map(item => item.submitUrl)
      urlList = urlList.filter(item => item !== undefined)
      urlList = [...urlList, ...this.fileIds]
      let params = {
        urls: urlList.join(','),
        code: this.taskEdit.code
      }
      this.$store.dispatch(UPDATETASKURLS, params)
    }
  },
  computed: {
    urlList () {
      if (this.taskEdit.urls) {
        return this.taskEdit.urls.map((item, index) => {
          return {
            url: item,
            submitUrl: this.taskEdit.urlList[index]
          }
        })
      }
      return []
    },
    assigneditMark () {
      return assignmentManage.state.assigneditMark
    },
    userInfo () {
      console.log(user)
      return user.state.userinfo
    }
  },
  watch: {
    assigneditMark: {
      deep: true,
      handler (val) {
        this.billDialog.visible = false
        this.fileIds = []
      }
    }
  }
}
</script>

<style scoped>
  .upload-text {
    color: #444;
    opacity: 0.9;
    font-family: sans-serif;
    font-size: 15px;
  }
  .bill-btn {
    font-size: 18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/components/supplementList.vue